import React from 'react'
import { SectionOne } from "./components/SectionOne";
import { SectionTwo } from "./components/SectionTwo";
import { SectionThree } from "./components/SectionThree";
import { SectionFour } from "./components/SectionFour";
import { SectionFive } from "./components/SectionFive";
import { SectionSix } from "./components/SectionSix";
import { SectionSeven } from './components/SectionSeven';
import { SectionEight } from './components/SectionEight';

export const Main = () => {
    return (
        <>
          <SectionOne />
          <SectionTwo />
          <SectionThree />
          <SectionFour />
          <SectionFive />
          <SectionSix />
          <SectionSeven />
          <SectionEight />
        </>
      );
}
